import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {
        putBalance,
        putBalanceConfirm,
        closePutBalance,
        handleAmount,
        admins,
    } = props;

    const {
        type,
        show,
        amount,
        is_need_original,
        email_for_original,
        email
    } = putBalance;

    return (
            <div className="invoice-modal__body">
                <label className="invoice-modal__label">Сумма для пополнения</label>
                <input
                    type="number"
                    min="0"
                    className="invoice-modal__input"
                    value={amount}
                    onChange={(e) => handleAmount(e.target.value, 'amount')}
                    />

                <label className="invoice-modal__label">На какой эл. адрес отправить скан</label>
                <input
                    type="email"
                    className="invoice-modal__input"
                    value={email}
                    onChange={(e) => handleAmount(e.target.value, 'email')}
                    />
                
                <div
                    className="checkboxes checkboxes_align-left invoice-modal__checkbox"
                    >
                    <label className="c-form__label" htmlFor="is_need_original">
                        <label className="custom-radio">
                            <input
                                checked={is_need_original === 1 ? true : false}
                                className="value"
                                type="checkbox"
                                id="is_need_original"
                                value={is_need_original}
                                onChange={(e) => handleAmount(is_need_original === 1 ? 0 : 1, 'is_need_original')}
                                />
                            <div></div>
                        </label>
                        <span className="text">Выслать оригиналы документов</span>
                    </label>
                </div>

                {/*Адрес для отправки оригинала счета и акта (по-умолчанию из профиля) */}
                <label className="invoice-modal__label">Адрес для отправки оригинала счета и акта</label>
                <input
                    type="email"
                    className="invoice-modal__input"
                    value={email_for_original}
                    onChange={(e) => handleAmount(e.target.value, 'email_for_original')}
                    />

            </div>    
    )
}


// WEBPACK FOOTER //
// ./src/components/Account/Balance/MakeInvoiceEntityForm.js